import { TotalsData } from "../../types";
import { ValueCard } from "../../styles";
import { formatMoneyCentsView } from "../../../../../utils/formatViews";

export const Totals: React.FC<{
  data: TotalsData;
  isAdmin: boolean;
}> = ({ data, isAdmin }) => {
  return (
    <>
      <ValueCard>
        <div>
          <p>
            <b>Valor não liquidado:</b>
          </p>
          <p>{formatMoneyCentsView(data.totalUnpaidValue)}</p>
        </div>

        <div>
          <p>
            <b>Número de linhas:</b>
          </p>
          <p>{data.totalRows}</p>
        </div>
      </ValueCard>
    </>
  );
};
